import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_LEADS_PER_MONTH: createSagaAction('GET_LEADS_PER_MONTH'),
  GET_LEADS_STATUS_COUNT_PER_MONTH: createSagaAction('GET_LEADS_STATUS_COUNT_PER_MONTH'),
  GET_DASHBOARD_FOLLOW_UPS: createSagaAction('GET_DASHBOARD_FOLLOW_UPS'),
  DASHBOARD_FOLLOW_UP_UPDATE: createSagaAction('DASHBOARD_FOLLOW_UP_UPDATE')
}

// Action Creators
export const actions = {
  getLeadsPerMonth: () => ({
    type: constants.GET_LEADS_PER_MONTH.ACTION
  }),

  getLeadsStatusCountPerMonth: () => ({
    type: constants.GET_LEADS_STATUS_COUNT_PER_MONTH.ACTION
  }),

  getDashboardFollowUps: ({ userId, show30d }) => ({
    type: constants.GET_DASHBOARD_FOLLOW_UPS.ACTION,
    userId,
    show30d
  }),

  updateDashboardFollowUp: ({ followUpId, userId, content }) => ({
    type: constants.DASHBOARD_FOLLOW_UP_UPDATE.ACTION,
    followUpId,
    userId,
    content
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    // leads per month chart
    case constants.GET_LEADS_PER_MONTH.ACTION:
      return { ...state, error: null, loadingLeadsPerMonth: true }
    case constants.GET_LEADS_PER_MONTH.SUCCESS:
      return {
        ...state,
        leadsOfMonth: action.payload,
        loadingLeadsPerMonth: false
      }
    // funnel
    case constants.GET_LEADS_STATUS_COUNT_PER_MONTH.ACTION:
      return { ...state, error: null, loadingLeadsStatusCount: true }
    case constants.GET_LEADS_STATUS_COUNT_PER_MONTH.SUCCESS:
      return {
        ...state,
        leadsStatusCount: action.payload,
        loadingLeadsStatusCount: false
      }
    // follow ups
    case constants.GET_DASHBOARD_FOLLOW_UPS.ACTION:
      return { ...state, error: null, loadingDashboardFollowUps: true }
    case constants.GET_DASHBOARD_FOLLOW_UPS.SUCCESS:
      return {
        ...state,
        dashboardFollowUps: action.payload,
        loadingDashboardFollowUps: false
      }
    case constants.DASHBOARD_FOLLOW_UP_UPDATE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/dashboard/dashboardActions.js